import { useState, useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
import { profilesService } from "../services/supabase/profiles";

interface UseUserTimezoneReturn {
  timezone: string;
}

export function useUserTimezone(): UseUserTimezoneReturn {
  const { user } = useAuth();
  const [timezone, setTimezone] = useState<string>(
    Intl.DateTimeFormat().resolvedOptions().timeZone
  );

  useEffect(() => {
    const fetchTimezone = async () => {
      if (!user?.id) return;

      try {
        const profile = await profilesService.getProfile(user.id);
        if (profile?.timezone) {
          setTimezone(profile.timezone);
        }
      } catch (error) {
        console.error("Error in fetchTimezone:", error);
      }
    };

    fetchTimezone();
  }, [user?.id]);

  return { timezone };
}